(() => {
  'use strict';
  if (window.top !== window || window.PrideDogsMail || !['https://pride-dogs.de','https://www.pride-dogs.de','https://pride-dogs.myshopify.com'].includes(location.origin)) return;
  const guestKey='pdmail-guest-v1';
  const checkoutKey='pdmail-checkout-v1',checkoutAttribute='__pdmail_checkout';
  let pendingGuest=null;
  let checkoutWork=null;
  const cartRoute=()=>{
    const route=new URL(window.Shopify?.routes?.root||'/',location.origin);
    if(route.origin!==location.origin||!route.pathname.endsWith('/')||route.search||route.hash)throw Error('route');
    return new URL('cart/update.js',route).href;
  };
  const removeCheckoutBinding=()=>{
    try{return fetch(cartRoute(),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{[checkoutAttribute]:''}})}).catch(()=>{})}catch{return Promise.resolve()}
  };
  const clearGuest=()=>{
    pendingGuest=null;
    try{
      const owned=sessionStorage.getItem(checkoutKey);sessionStorage.removeItem(guestKey);sessionStorage.removeItem(checkoutKey);
      if(owned)void removeCheckoutBinding();
    }catch{}
  };
  const privacyDecision=()=>{
    try{
      const p=window.Shopify?.customerPrivacy;
      if(typeof p?.analyticsProcessingAllowed!=='function'||typeof p?.marketingAllowed!=='function')return null;
      const analytics=p.analyticsProcessingAllowed(),marketing=p.marketingAllowed();
      if(typeof analytics!=='boolean'||typeof marketing!=='boolean')return null;
      return analytics&&marketing;
    }catch{return null}
  };
  const allowed=()=>{const decision=privacyDecision();if(decision===false)clearGuest();return decision===true};
  const guestToken=()=>{
    try{
      const config=document.getElementById('pride-dogs-mail-config')?.dataset;
      if(config?.guestBrowserEnabled!=='true'||config?.customerPresent==='true'){clearGuest();return null}
      // Missing privacy API is not refusal. Keep the return token only in this
      // closure until readiness; do not access storage or collect in the meantime.
      const decision=privacyDecision();if(decision===null)return null;
      if(decision===false){clearGuest();return null}
      const token=pendingGuest||sessionStorage.getItem(guestKey);if(!token)return null;
      if(!/^[A-Za-z0-9_-]+\.[a-f0-9]{64}$/.test(token)||token.length>1024){clearGuest();return null}
      const payload=JSON.parse(atob(token.split('.')[0].replaceAll('-','+').replaceAll('_','/')));
      if(typeof payload.exp!=='number'||typeof payload.iat!=='number'||!Number.isFinite(payload.exp)||!Number.isFinite(payload.iat)||payload.exp<=Date.now()/1000||payload.iat>Date.now()/1000||payload.exp-payload.iat>900){clearGuest();return null}
      if(pendingGuest){sessionStorage.setItem(guestKey,token);pendingGuest=null}
      return token;
    }catch{clearGuest();return null}
  };
  // Fragments never reach the server. Remove immediately, before privacy loads.
  if(typeof location.hash==='string'&&location.hash.startsWith('#pdmail-guest=')){
    const token=location.hash.slice('#pdmail-guest='.length);
    try{history.replaceState(null,'',location.pathname+location.search)}catch{}
    const config=document.getElementById('pride-dogs-mail-config')?.dataset;
    if(config?.guestBrowserEnabled==='true'&&config?.customerPresent!=='true'&&token.length<=1024)pendingGuest=token;
    else clearGuest();
  }
  guestToken();
  const checkoutToken=()=>document.getElementById('pride-dogs-mail-config')?.dataset.guestCheckoutEnabled==='true'?guestToken():null;
  const prepareCheckout=()=>{
    if(checkoutWork)return checkoutWork;
    const token=checkoutToken();if(!token)return Promise.resolve(false);
    checkoutWork=(async()=>{
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),2000);
      try{
        const browser=JSON.parse(atob(token.split('.')[0].replaceAll('-','+').replaceAll('_','/')));
        let binding;try{const saved=JSON.parse(sessionStorage.getItem(checkoutKey));if(saved?.token===token)binding=saved.binding}catch{}
        if(!binding){
          const body=JSON.stringify({token,consent:{analytics:true,marketing:true}});
          const digest=[...new Uint8Array(await crypto.subtle.digest('SHA-256',new TextEncoder().encode(body)))].map(v=>v.toString(16).padStart(2,'0')).join('');
          if(checkoutToken()!==token||controller.signal.aborted)return false;
          const response=await fetch('/apps/pride-dogs-mail/checkout-binding?body_sha256='+digest,{method:'POST',credentials:'same-origin',mode:'same-origin',headers:{'Content-Type':'text/plain;charset=UTF-8'},body,signal:controller.signal});
          if([403,409,410].includes(response.status)){clearGuest();return false}
          if(response.status!==202)return false;
          const reply=await response.json();
          if(reply.accepted!==true||reply.attribute!==checkoutAttribute||typeof reply.test_only!=='boolean')return false;
          binding=reply.binding;
        }
        if(typeof binding!=='string'||binding.length>255||!/^[A-Za-z0-9_-]+\.[a-f0-9]{64}$/.test(binding))return false;
        const proof=JSON.parse(atob(binding.split('.')[0].replaceAll('-','+').replaceAll('_','/'))),now=Date.now()/1000;
        if(proof.v!==1||proof.c!==browser.challenge_id||proof.r!==browser.revision||!Number.isSafeInteger(proof.i)||!Number.isSafeInteger(proof.e)||proof.i>now||proof.e<=now||proof.e>browser.exp||proof.e-proof.i>900||proof.e<=proof.i||![0,1].includes(proof.t))return false;
        if(checkoutToken()!==token||controller.signal.aborted)return false;
        sessionStorage.setItem(checkoutKey,JSON.stringify({token,binding}));
        const response=await fetch(cartRoute(),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{[checkoutAttribute]:binding}}),signal:controller.signal});
        if(checkoutToken()!==token){await removeCheckoutBinding();return false}
        return response.ok===true;
      }catch{return false}finally{clearTimeout(timer)}
    })().finally(()=>{checkoutWork=null});
    return checkoutWork;
  };
  const replayCheckout=new WeakSet();
  const checkoutIntent=async event=>{
    const target=event.type==='submit'?event.target:event.target?.closest?.('a[href]');
    if(!target)return;
    if(replayCheckout.has(target)){replayCheckout.delete(target);return}
    if(event.defaultPrevented||!checkoutToken()||event.type==='click'&&(event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||target.target&&target.target!=='_self'||target.hasAttribute('download')))return;
    const url=new URL(event.type==='submit'?target.action:target.href,location.origin);
    if(url.origin!==location.origin)return;
    const checkout=/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?checkout\/?$/.test(url.pathname);
    const cartSubmit=event.type==='submit'&&/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?cart\/?$/.test(url.pathname)&&event.submitter?.name==='checkout';
    if(!checkout&&!cartSubmit)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(target.prideDogsCheckoutPending)return;
    target.prideDogsCheckoutPending=true;
    const submitter=event.submitter;
    try{await prepareCheckout()}finally{
      target.prideDogsCheckoutPending=false;
      if(target.isConnected){replayCheckout.add(target);if(event.type==='submit')target.requestSubmit(submitter||undefined);else target.click()}
    }
  };
  document.addEventListener('click',checkoutIntent,true);
  document.addEventListener('submit',checkoutIntent,true);
  const cleanProduct = item => {
    if (!item || typeof item!=='object') throw Error('product');
    const id=String(item.id), url=new URL(item.url,location.origin);
    url.search='';url.hash='';
    if (!/^gid:\/\/shopify\/Product\/[1-9][0-9]*$/.test(id) || url.origin!==location.origin || !/^\/products\/[a-zA-Z0-9_-]+$/.test(url.pathname) || typeof item.name!=='string' || item.name.length>200 || /[\u0000-\u001f]/.test(item.name) || !Number.isFinite(item.price) || item.price<0 || item.price>100000 || !/^[A-Z]{3}$/.test(item.currency)) throw Error('product');
    const product={id,name:item.name,url:url.href,price:item.price,currency:item.currency};
    if(item.image_url){const image=new URL(item.image_url,location.origin);image.search='';image.hash='';if(image.protocol!=='https:' || !(image.hostname==='cdn.shopify.com'||(image.origin===location.origin&&image.pathname.startsWith('/cdn/shop/'))) || image.username || image.password || image.port)throw Error('image');product.image_url=image.href;}
    return product;
  };
  const send = async (name, product=null) => {
    if(!allowed()) return false;
    try {
      const event={id:crypto.randomUUID(),name,occurred_at:Date.now()/1000,product,consent:{analytics:true,marketing:true}};
      const token=guestToken();
      const body=JSON.stringify(token?{token,event}:event);
      const digest=[...new Uint8Array(await crypto.subtle.digest('SHA-256',new TextEncoder().encode(body)))].map(v=>v.toString(16).padStart(2,'0')).join('');
      if(!allowed()){clearGuest();return false}
      if(token&&guestToken()!==token)return false;
      const result=await fetch('/apps/pride-dogs-mail/'+(token?'guest-events':'events')+'?body_sha256='+digest,{method:'POST',credentials:'same-origin',mode:'same-origin',headers:{'Content-Type':'text/plain;charset=UTF-8'},body,keepalive:true});
      if(token&&[403,409,410].includes(result.status))clearGuest();
      return result.status===202;
    } catch { return false; }
  };
  const cartResponses=new WeakSet();
  window.PrideDogsMail=Object.freeze({
    prepareCheckout,
    cartAddResponse: async response => {
      if(!allowed() || !response || typeof response!=='object' || cartResponses.has(response))return false;
      try {
        const currency=document.getElementById('pride-dogs-mail-config')?.dataset.currency;
        const items=Object.hasOwn(response,'items')?response.items:[response];
        if(!Array.isArray(items) || !items.length || items.length>100) return false;
        const products=items.map(item=>{
          if(!Number.isSafeInteger(item.product_id) || item.product_id<=0 || !Number.isSafeInteger(item.price) || item.price<0)throw Error('cart');
          return cleanProduct({id:'gid://shopify/Product/'+item.product_id,name:item.product_title,url:item.url,price:item.price/100,currency,image_url:item.featured_image?.url || item.image});
        });
        cartResponses.add(response);
        const results=await Promise.all(products.map(product=>send('product_added_to_cart',product)));
        return results.every(Boolean);
      } catch { return false; }
    },
    cartAdded: async product => {if(!allowed())return false;try{return await send('product_added_to_cart',cleanProduct(product));}catch{return false;}}
  });
  let observed=false;
  const observe = () => {
    guestToken();
    if(allowed())void prepareCheckout();
    if(observed || !allowed())return;
    observed=true;
    void send('page_viewed');
    try {const source=document.getElementById('pride-dogs-mail-product');if(source?.dataset.product)void send('product_viewed',cleanProduct(JSON.parse(source.dataset.product)));}catch{}
  };
  document.addEventListener('visitorConsentCollected',observe);
  document.addEventListener('DOMContentLoaded',observe,{once:true});
  if(window.Shopify?.customerPrivacy)observe();
  if(typeof window.Shopify?.loadFeatures==='function')window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)observe();});
})();

(() => {
 'use strict';
 if(window.top!==window||!['https://pride-dogs.de','https://www.pride-dogs.de','https://pride-dogs.myshopify.com'].includes(location.origin))return;
 for(const form of document.querySelectorAll('[data-pd-doi]')){
  if(form.dataset.bound==='true')continue;
  form.dataset.bound='true';
  const consent=form.querySelector('[name="newsletter_consent"]'),button=form.querySelector('button'),status=form.querySelector('[role="status"]');
  let pending=false;
  form.addEventListener('submit',async event=>{
   event.preventDefault();if(pending||!consent.checked)return;
   pending=true;button.disabled=true;
   try{
    if(!/^[a-zA-Z0-9_-]{1,128}$/.test(form.dataset.formId||''))throw Error('form');
    const guest=form.dataset.guest==='true',testOnly=form.dataset.testOnly==='true';
    const data={form_id:form.dataset.formId,request_id:crypto.randomUUID(),requested_at:Date.now()/1000,test_only:testOnly};
    if(guest){const email=form.querySelector('[name="newsletter_email"]');if(!email||!email.value.trim())throw Error('email');data.email=email.value.trim()}
    const body=JSON.stringify(data);
    const digest=[...new Uint8Array(await crypto.subtle.digest('SHA-256',new TextEncoder().encode(body)))].map(n=>n.toString(16).padStart(2,'0')).join('');
    if(!consent.checked)throw Error('withdrawn');
    const result=await fetch('/apps/pride-dogs-mail/'+(guest?'doi-guest-request':'doi-request')+'?body_sha256='+digest,{method:'POST',credentials:'same-origin',mode:'same-origin',headers:{'Content-Type':'text/plain;charset=UTF-8'},body});
    const payload=await result.json();
    if(result.status!==202||payload.accepted!==true||payload.test_only!==testOnly)throw Error('unavailable');
    status.textContent='Deine Anfrage wurde angenommen. Deine Anmeldung wird erst nach Bestätigung per E-Mail wirksam.';
   }catch{status.textContent='Die Anmeldung konnte nicht bestätigt werden. Bitte versuche es später erneut.'}
   // No automatic retry after an ambiguous response.
  });
 }
})();
